import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';


export const setAuthUser = (data) => {
  
  // localStorage.setItem("authorizationToken", JSON.stringify(data));
  Cookies.set('authorization', data.authToken, { expires: 1 });
  Cookies.set('customToken', data.refreshToken, { expires: 7 });
  Cookies.set('authUser', JSON.stringify(data.user), { expires: 1 });

};

export const getAuthUser = () => {
  const user = Cookies.get('authUser') ? JSON.parse(Cookies.get('authUser')) : null;
  return { user };
};